<div class="delivery-date-preview-row">
  <span class="delivery-date-preview" [innerHTML]="renderedHtml | safe"></span>
  @if (linkedCutoffHtml) {
    <span class="delivery-date-preview__cutoff" [innerHTML]="linkedCutoffHtml | safe"></span>
  }
</div>
